module.exports = __webpack_public_path__ + "static/img/mumi-2.5a846e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/mumi-2.jpg
// module id = t9iB
// module chunks = 1